import PaginationControlsController from './paginationControls.controller';
import './paginationControls.css';

const template = require<string>('./paginationControls.html');

const paginationControlsComponent:ng.IComponentOptions = {
  bindings: {
    onPageChange: '&',
    currentPage: '=',
    count: '<',
    pageSize: '<'
  },
  transclude: true,
  controller: PaginationControlsController,
  template
};
export default paginationControlsComponent;


/** WEBPACK FOOTER **
 ** ./app/common/components/paginationControls/paginationControls.component.ts
 **/